import { render, staticRenderFns } from "./GroupsBeverages.vue?vue&type=template&id=65cca396&"
import script from "./GroupsBeverages.vue?vue&type=script&lang=js&"
export * from "./GroupsBeverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports